import { isUserIdle, onActivityResume } from "../services/activity.service";

export function createActivityAwarePoller({ interval, shouldRun, onTick }) {
    let timeoutId = null;
    let resumeUnsubscribe = null;
    let running = false;

    function clearResumeWait() {
        if (resumeUnsubscribe) {
            resumeUnsubscribe();
            resumeUnsubscribe = null;
        }
    }

    function schedule(delay) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(tick, delay);
    }

    async function tick() {
        if (!running) {
            return;
        }

        if (isUserIdle()) {
            if (!resumeUnsubscribe) {
                resumeUnsubscribe = onActivityResume(() => {
                    clearResumeWait();
                    if (running) {
                        schedule(0);
                    }
                });
            }
            return;
        }

        clearResumeWait();

        if (!shouldRun()) {
            if (running) {
                schedule(interval);
            }
            return;
        }

        try {
            await onTick();
        } catch (e) {
            console.log(e);
        }

        if (running) {
            schedule(interval);
        }
    }

    return {
        start() {
            if (running) {
                return;
            }

            running = true;
            schedule(0);
        },
        stop() {
            running = false;
            clearTimeout(timeoutId);
            timeoutId = null;
            clearResumeWait();
        },
        isRunning() {
            return running;
        },
    };
}
